import React, { Component } from "react";
import ReactDOM from "react-dom";
import { HotTable } from "@handsontable/react";
import * as _ from "lodash";

class RunTable extends Component {
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
    }

    render() {
        const { oet, status } = this.props;
        const data = this.getData(oet);
        const oetId = oet ? oet.id : null;
        const table_op = {
            width: "100%",
            height: 500,
            stretchH: "all",
            // beforeChange: this.onBeforeHotChange,
            settings: {
                tableClassName: ["table", "table-bordered", "table-striped"],
                fillHandle: true,
                // disableVisualSelection: true,
                wordWrap: true,
                stretchH: "none",
                className: "htCenter htMiddle",
                colHeaders: this.getColHeaders(status),
                columns: this.getColumns(status, oetId),
                data
            }
        };
        return (
            <div>
                <HotTable ref={this.hotTableComponent} {...table_op} />
            </div>
        );
    }

    onBeforeHotChange = (changes, source) => {
        const hot = this.hotTableComponent.current.hotInstance;
        if (source === "edit") {
            const { oet, onItemsChange } = this.props;
            const [row, key, , newValue] = changes[0];
            const dataRow = hot.getSourceDataAtRow(row);
            const oldItem = oet.items.find(item => item.id === dataRow.id);
            let newItem = null;
            if (oldItem.hasOwnProperty(key)) {
                newItem = Object.assign({}, oldItem);
                newItem[key] = newValue;
            }
            onItemsChange({ oldItem, newItem });
        }
    };

    getColHeaders = () => ["Name", "Original<br/> Run ID", "Creation Type", "Customer Material<br>Code/No.", "Status"];

    getColumns = (status, oet_id) => {
        const { history } = this.props;
        // const is_editable = !(status > 0);
        const res = [
            {
                data: "name",
                editor: false,
                renderer: (...args) => {
                    const [, td, , , , value] = args;
                    td.className = ["htCenter11", "htCenter"].join(" ");
                    if (oet_id && value) {
                        const url = `/non-sode/run/${oet_id}/${value.id}`;
                        ReactDOM.render(
                            <a
                                href={url}
                                onClick={ev => {
                                    ev.preventDefault();
                                    history.push(url);
                                    return false;
                                }}
                            >
                                {value.n}
                            </a>,
                            td
                        );
                    }
                    return td;
                }
            },
            {
                data: "original_run",
                editor: false,
                renderer: (...args) => {
                    const [, td, , , , value] = args;
                    td.className = ["htCenter11", "htCenter"].join(" ");
                    if (oet_id && value && value.id && value.number) {
                        const url = `/non-sode/run/${oet_id}/${value.id}`;
                        ReactDOM.render(
                            <a
                                href={url}
                                onClick={ev => {
                                    ev.preventDefault();
                                    history.push(url);
                                    return false;
                                }}
                            >
                                Run #{value.number}
                            </a>,
                            td
                        );
                    }
                    return td;
                }
            },
            {
                data: "action",
                editor: false,
                renderer: (...args) => {
                    const [, td, , , , value] = args;
                    td.className = ["htCenter11", "htCenter"].join(" ");
                    if (value && value !== "normal") {
                        let newVal = "Normal";
                        switch (value) {
                            case "partial_cancel":
                                newVal = "Partially Cancel";
                                break;
                            case "amend":
                                newVal = "Amend";
                                break;
                            default:
                                break;
                        }
                        ReactDOM.render(newVal, td);
                    }
                    return td;
                }
            },
            {
                data: "code",
                editor: false,
                className: "htLeft htMiddle"
            },
            {
                data: "status_display",
                editor: false,
                className: "htLeft htMiddle"
            }
        ];
        return res;
    };

    getData = oet => {
        if (oet) {
            const { runs, items } = oet;
            if (runs) {
                const res = _.orderBy(runs, ["number"], ["asc"]).map(run => {
                    const item = items.find(item => item.id === run.oet_item);
                    if (item) {
                        return {
                            ...run,
                            code: item.code,
                            name: { n: `Run #${run.number}`, id: run.id }
                        };
                    }
                    return null;
                });
                return res;
            }
        }
        return [{}];
    };
}

export default RunTable;
